/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Assign_TitleInputs */

const vi_cdo_assign_title = /** @type {(inputs: Cdo_Assign_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gán tài xế`)
};

/**

* @param {Cdo_Assign_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_assign_title = /** @type {((inputs?: Cdo_Assign_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Assign_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_assign_title(inputs)
});